enum Platform {
  SCRATCH = 'Scratch',
  SCRATCHJR = 'ScratchJr',
  KODALBLE = 'Kodable',
  CODE_ORG = 'Code.org',
  HOPSCOTCH = 'Hopscotch',
  MIT_APP_INVENTOR = 'MIT App Inventor',
  THUNKABLE = 'Thunkable',
  REPL_IT = 'Repl.it',
  ARDUINO_IDE = 'Arduino IDE',
  OTHER = 'Other', // Other will show as whatever text the user entered
}

export default Platform;
